import { render, staticRenderFns } from "./GvcPdf.vue?vue&type=template&id=58875a95&scoped=true&"
import script from "./GvcPdf.vue?vue&type=script&lang=js&"
export * from "./GvcPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58875a95",
  null
  
)

export default component.exports